/**
 * Coalesces concurrent auth/bootstrap fetches for the same logical key
 * (in-memory, current tab only).
 */
const inflight = new Map<string, Promise<unknown>>();

export function runAuthContextDeduped<T>(key: string, fn: () => Promise<T>): Promise<T> {
  const existing = inflight.get(key) as Promise<T> | undefined;
  if (existing) {
    return existing;
  }
  const p = fn().finally(() => {
    inflight.delete(key);
  }) as Promise<T>;
  inflight.set(key, p);
  return p;
}
